module.exports = __webpack_public_path__ + "static/media/sourcesanspro-bold-webfont.86937a00.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/sourcesanspro-bold-webfont.ttf
// module id = 281
// module chunks = 0